$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

window.executeExternalRequest = function (callback){
    delete $.ajaxSettings.headers["X-CSRF-TOKEN"]; // Remove header before call

    callback();

    $.ajaxSettings.headers["X-CSRF-TOKEN"] = $('meta[name="csrf-token"]').attr('content');
}



// WEBPACK FOOTER //
// ./resources/assets/js/ajax-setup-csrf.js